import createIcon from '../../createIcon';

/**
 * @component @name ViewInAr
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMjUgNy42TDEyLjc1IDQuNDJDMTIuMjkgNC4xNSAxMS43MSA0LjE1IDExLjI1IDQuNDJMNS43NSA3LjZDNS4yOSA3Ljg3IDUgOC4zNiA1IDguOVYxNS4yNUM1IDE1Ljc5IDUuMjkgMTYuMjggNS43NSAxNi41NUwxMS4yNSAxOS43M0MxMS43MSAyMCAxMi4yOSAyMCAxMi43NSAxOS43M0wxOC4yNSAxNi41NUMxOC43MSAxNi4yOCAxOSAxNS43OSAxOSAxNS4yNVY4LjlDMTkgOC4zNiAxOC43MSA3Ljg3IDE4LjI1IDcuNlpNNyAxNC45NlYxMC4zNEwxMSAxMi42NlYxNy4yN0w3IDE0Ljk2Wk0xMiAxMC45M0w4IDguNjFMMTIgNi4zTDE2IDguNjFMMTIgMTAuOTNaTTEzIDE3LjI3VjEyLjY2TDE3IDEwLjM0VjE0Ljk2TDEzIDE3LjI3Wk03IDJIMy41QzIuNjcgMiAyIDIuNjcgMiAzLjVWN0g0VjRIN1YyWk0xNyAySDIwLjVDMjEuMzMgMiAyMiAyLjY3IDIyIDMuNVY3SDIwVjRIMTdWMlpNNyAyMkgzLjVDMi42NyAyMiAyIDIxLjMzIDIgMjAuNVYxN0g0VjIwSDdWMjJaTTE3IDIySDIwLjVDMjEuMzMgMjIgMjIgMjEuMzMgMjIgMjAuNVYxN0gyMFYyMEgxN1YyMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewInAr = createIcon('ViewInAr', [
  [
    'path',
    {
      d: 'M18.25 7.6L12.75 4.42C12.29 4.15 11.71 4.15 11.25 4.42L5.75 7.6C5.29 7.87 5 8.36 5 8.9V15.25C5 15.79 5.29 16.28 5.75 16.55L11.25 19.73C11.71 20 12.29 20 12.75 19.73L18.25 16.55C18.71 16.28 19 15.79 19 15.25V8.9C19 8.36 18.71 7.87 18.25 7.6ZM7 14.96V10.34L11 12.66V17.27L7 14.96ZM12 10.93L8 8.61L12 6.3L16 8.61L12 10.93ZM13 17.27V12.66L17 10.34V14.96L13 17.27ZM7 2H3.5C2.67 2 2 2.67 2 3.5V7H4V4H7V2ZM17 2H20.5C21.33 2 22 2.67 22 3.5V7H20V4H17V2ZM7 22H3.5C2.67 22 2 21.33 2 20.5V17H4V20H7V22ZM17 22H20.5C21.33 22 22 21.33 22 20.5V17H20V20H17V22Z',
      key: '1ab70d',
    },
  ],
]);

export default ViewInAr;
